module.exports = __webpack_public_path__ + "img/iob.e9957958.jpg";